import _slicedToArray from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { calculateRem as o, hexToRgba as n } from "@vds-core/utilities";
import { AccessibilityTokens as i } from "@vds-tokens/accessibility";
import { ColorTokens as r } from "@vds-tokens/color";
import { ComponentTokens as a } from "@vds-tokens/component";
import { useState as l } from "react";
import c from "styled-components";
var u = c.label.withConfig({
    displayName: "StyledLabel",
    componentId: "VDS__sc-hvmk2k-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: 1rem;\n  height: ", ";\n  width: ", ";\n  overflow: hidden;\n  -webkit-tap-highlight-color: transparent;\n  ", "\n"])), function (_ref) {
    var e = _ref.toggleHeight;
    return o(e);
  }, o(52), function (_ref2) {
    var e = _ref2.disabled,
      t = _ref2.surface,
      n = _ref2.$keyboardFocused;
    return !e && n && "\n      &:not(:hover) {\n        outline: none;\n        &::before {\n          border: ".concat(o(i.focusring.borderwidth.value), " ").concat(i.focusring.borderstyle.value, " ").concat("dark" === t ? i.color.focusring.ondark.value : i.color.focusring.onlight.value, ";\n          border-radius: 1rem;\n          content: '';\n          height: calc(100% + ").concat(o(4), ");\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat(o(4), ");\n        }\n      }\n      ");
  }),
  d = c.span.withConfig({
    displayName: "ToggleSwitchSlider",
    componentId: "VDS__sc-hvmk2k-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-radius: 1rem;\n   border: ", ";\n    box-sizing: border-box;\n    position: relative;\n    display: inline-flex;\n    cursor: ", ";\n    background-color: ", ";\n    color: ", ";\n    height: ", ";\n    transition: background-color 100ms;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    width: ", ";\n    pointer-events: auto;\n    &::before {\n      background-color: ", ";\n      border-radius: 50%;\n      bottom: 0;\n      content: '';\n      height: ", ";\n      left: ", " !important; \n      margin-bottom: auto;\n      margin-top: auto;\n      padding-left: 0;\n      position: absolute;\n      top: 0;\n      transition: left 100ms;\n      width: ", ";\n      z-index: 1;\n      box-shadow: ", ";\n      margin: ", "\n      };\n    }\n  \n    &:active,\n    &:focus {\n      outline: none;\n    }\n  "])), function (_ref3) {
    var e = _ref3.disabled,
      t = _ref3.surface,
      n = _ref3.$surfaceType;
    return "media" === n ? e ? "".concat(o(1), " solid ").concat(r.interactive.disabled["on".concat(t)].value) : "".concat(o(1), " solid ").concat(a.toggle.border.media["on".concat(t)].value) : "".concat(o(1), " solid transparent");
  }, function (_ref4) {
    var e = _ref4.disabled;
    return e ? null : "pointer";
  }, function (_ref5) {
    var e = _ref5.disabled,
      t = _ref5.$on,
      o = _ref5.surface,
      i = _ref5.$surfaceType;
    return function (e, t, o, i) {
      return e ? r.interactive.disabled["on".concat(o)].value : "media" === i ? t ? r.palette.green36.value : n(r.palette.gray20.value, .5) : t ? a.toggle.container.on["on".concat(o)].value : r.palette.gray44.value;
    }(e, t, o, i);
  }, function (_ref6) {
    var e = _ref6.$calculateTextColor,
      t = _ref6.disabled,
      o = _ref6.surface;
    return null == e ? void 0 : e(t, o);
  }, function (_ref7) {
    var e = _ref7.$toggleHeight;
    return o(e);
  }, o(52), function (_ref8) {
    var e = _ref8.disabled,
      t = _ref8.surface;
    return function (e, t) {
      return e ? a.toggle.knob.disabled["on".concat(t)].value : r.palette.white.value;
    }(e, t);
  }, function (_ref9) {
    var e = _ref9.$knobSize;
    return o(e);
  }, function (_ref0) {
    var e = _ref0.$knobLeftPosition,
      t = _ref0.$on;
    return t ? o(e) : 0;
  }, function (_ref1) {
    var e = _ref1.$knobSize;
    return o(e);
  }, function (_ref10) {
    var e = _ref10.disabled;
    return function (e) {
      return e ? "0px 1px 10px ".concat(n(r.palette.black.value, .1), ", 0px 2px 4px ").concat(n(r.palette.black.value, .04)) : "0px 1px 10px ".concat(n(r.palette.black.value, .24), ", 0px 2px 4px ").concat(n(r.palette.black.value, .08));
    }(e);
  }, o(1)),
  s = c.input.withConfig({
    displayName: "ToggleInput",
    componentId: "VDS__sc-hvmk2k-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: 0;\n  margin: 0;\n  width: 2rem;\n  height: 1rem;\n  position: absolute;\n  top: 0;\n  pointer-events: auto;\n  &:hover {\n    cursor: pointer;\n  }\n"]))),
  p = function p(o) {
    var _l = l(!1),
      _l2 = _slicedToArray(_l, 2),
      n = _l2[0],
      i = _l2[1],
      _o$on = o.on,
      r = _o$on === void 0 ? !1 : _o$on,
      _o$disabled = o.disabled,
      a = _o$disabled === void 0 ? !1 : _o$disabled,
      c = o.onKeyDown,
      p = o.handleSwitchClick,
      _o$onChange = o.onChange,
      b = _o$onChange === void 0 ? function () {} : _o$onChange,
      f = o.tabIndex,
      g = o.name,
      $ = o.value,
      m = o.calculateTextColor,
      h = o.analyticsTrack,
      k = o.track,
      v = o.trackIgnore,
      x = o.clickStream,
      y = o.surface,
      w = o.surfaceType,
      S = o.inputId,
      T = o.focusId,
      C = o.textPosition,
      I = o.showText,
      z = o.ariaLabel,
      _ = o.toggleHeight,
      D = o.knobSize,
      H = o.knobLeftPosition,
      L = r;
    return e(u, {
      id: T,
      disabled: a,
      surface: y,
      htmlFor: S || g || "toggle",
      $keyboardFocused: n,
      $toggleHeight: _,
      children: [t(s, {
        "data-testid": "test-toggle",
        "aria-label": z || g,
        type: "checkbox",
        disabled: a,
        checked: L,
        name: g,
        value: $,
        id: S || g || "toggle",
        tabIndex: f,
        "data-analyticstrack": h,
        "data-track": k,
        "data-track-ignore": v,
        "data-clickstream": x,
        onFocus: function onFocus() {
          i(!0);
        },
        onBlur: function onBlur() {
          i(!1);
        },
        onChange: b,
        onKeyDown: c,
        onClick: function onClick(e) {
          return p && p(e);
        }
      }), t(d, {
        tabIndex: -1,
        "aria-hidden": !0,
        surface: y,
        $surfaceType: w,
        disabled: a,
        $on: L,
        $calculateTextColor: m,
        $textPosition: C,
        $showText: I,
        $toggleHeight: _,
        $knobSize: D,
        $knobLeftPosition: H
      })]
    });
  };
export { p as default };